import { render } from "./Empleados.vue?vue&type=template&id=7a5310a4"
import script from "./Empleados.vue?vue&type=script&lang=js"
export * from "./Empleados.vue?vue&type=script&lang=js"

import exportComponent from "/mnt/gasoil_files/gasoil/docker/gasoil/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__